import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import { ReactNode, useEffect, useState } from 'react';

import { namespaces } from '@frontend/locales';

export interface I18nProviderProps {
  children: ReactNode;
}

export interface I18nProviderState {
  loading: boolean;
  error: any | undefined;
  language: string;
  locale: Intl.Locale;
}

// The app only ships en-GB; nothing changes the language after start-up.
const LANGUAGE = 'en-GB';

export const useI18n = () => {
  const [state, setState] = useState<I18nProviderState>({
    loading: true,
    error: undefined,
    language: LANGUAGE,
    locale: new Intl.Locale(LANGUAGE),
  });

  useEffect(() => {
    i18next.use(Backend).init(
      {
        ns: [...namespaces],
        load: 'currentOnly',
        fallbackLng: 'en-GB',
        lng: LANGUAGE,
        backend: {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
      },
      (error) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          error,
        }));
      },
    );
  }, []);

  if (import.meta && import.meta.hot) {
    import.meta.hot.on('locales-update', () => {
      setState((prev) => ({
        ...prev,
        loading: true,
      }));

      i18next
        .reloadResources()
        .then(() => i18next.changeLanguage(i18next.language))
        .then(() => {
          setState((prev) => ({
            ...prev,
            loading: false,
          }));
        });
    });
  }

  return state;
};
